export default __webpack_public_path__ + "static/media/crew-07-bit.a3ea67da.svg";